import React, { InputHTMLAttributes } from 'react';
import styled from 'styled-components';
import { CardHeader } from './Card';

type DashboardCardProps = {
  icon: React.ReactNode;
} & InputHTMLAttributes<HTMLDivElement>;

export const DashboardCard = ({
  icon,
  children,
  ...rest
}: DashboardCardProps) => {
  return (
    <StyledDashboardCard {...rest}>
      <DashboardCardIcon>{icon}</DashboardCardIcon>
      <DashboardCardContent>{children}</DashboardCardContent>
    </StyledDashboardCard>
  );
};

const StyledDashboardCard = styled.div`
  display: flex;
  flex-direction: row;
  color: var(--blue);
  cursor: pointer;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);

  border-radius: 10px;
  background: var(--primary-color8);

  :hover {
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);

    ${CardHeader} {
      i {
        margin-right: -8px;
      }
    }
  }
`;

const DashboardCardContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem;
  width: calc(100% - 6rem);
`;

const DashboardCardIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;

  i {
    height: 4rem;
    width: 4rem;
    text-align: center;
    line-height: 4rem;
    font-size: 2rem;
    background: rgba(0, 0, 0, 0.2);
    border-radius: 50%;
  }
`;
